import React from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormProvider, useForm } from "react-hook-form";

import StyledModal from "components/Modal";
import { FormInput } from "components/FormInput";

import { useAppDispatch } from "store/hooks";
import { updateUserPassword } from "store/features/userSlice";
import { setNotification } from "store/features/notificationSlice";

import { FormValues, validationSchema } from "./validation";

interface UpdatePasswordModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const UpdatePasswordModal: React.FC<UpdatePasswordModalProps> = (props) => {
  const { isOpen, onClose } = props;
  const dispatch = useAppDispatch();

  const methods = useForm<FormValues>({
    mode: "onSubmit",
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = async () => {
    await methods.handleSubmit(async (values: FormValues) => {
      await dispatch(updateUserPassword(values)).unwrap();
      onCloseModal();

      dispatch(
        setNotification({
          severity: "success",
          message: "Пароль успішно оновлено",
        })
      );
    })();
  };

  const onCloseModal = () => {
    methods.reset({ currentPassword: "", newPassword: "" });
    onClose();
  };

  return (
    <StyledModal
      isOpen={isOpen}
      onClose={onCloseModal}
      title={"Оновити пароль"}
      content={
        <FormProvider {...methods}>
          <FormInput
            title="Старий пароль"
            name="currentPassword"
            fullWidth
            type="password"
          />
          <FormInput
            title="Новий пароль"
            name="newPassword"
            fullWidth
            type="password"
          />
        </FormProvider>
      }
      onAction={onSubmit}
    />
  );
};

export default UpdatePasswordModal;
